import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {catchError, map, retry} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {MessageService} from '../../_util/message.service';
import {config} from "../../../../environments/config";
import { AlertService } from '../alert/alert.service';

@Injectable({
    providedIn: 'root',
})
export class SgfMensajesService {

    constructor(
        private router: Router,
        private http: HttpClient,
        private messageSrv: MessageService,
        private alertService: AlertService,
    ) { }

    getAll() {
        return this.http.get<any>(`${config.apiUrl}/sms/create`);
    }
    register(id: string) {
        const params = new HttpParams()
            .set('token', id);
        return this.http.post<any>(`${config.apiUrl}/spi/clavetransaccion`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            })
            .catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }
    mensajeLging(usuario: string, password: string, ip: string, token: string) {
        const params = new HttpParams()
            .set('username', usuario)
            .set('password', password)
            .set('ip', ip)
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/login/sendMail`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            })
            .catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }
    public findOne(id, clave) {
        const body = new HttpParams()
            .set('token', id)
            .set('clave', clave);
        return this.http.post<any>(`${config.apiUrl}/weblogin/clavetemporal/v2`, body)
            .toPromise()
            .then(res => <any>res)
            .then(data => {return data;})
            .catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }
}
